import { useSaveTaskFeedbackMutation, useAnswerOnTaskMutation } from '../tasksApi';
import { enqueueSnackbar } from 'notistack';
import { TOAST_SUCCESS, TOAST_ERROR } from '../../../utils/constants';
import i18next from 'i18next';

export const useTasksActions = () => {
  const [saveTaskFeedbackTrigger] = useSaveTaskFeedbackMutation();
  const [answerOnTaskTrigger] = useAnswerOnTaskMutation();

  const saveTaskFeedback = async ({ feedbackData, courseId }) => {
    try {
      const result = await saveTaskFeedbackTrigger({ feedbackData, courseId }).unwrap();
      enqueueSnackbar(i18next.t('tasks.taskFeedbackSaved'), { variant: TOAST_SUCCESS });
      return result;
    } catch (error) {
      enqueueSnackbar(i18next.t('tasks.saveFeedbackFailed'), { variant: TOAST_ERROR });
      throw error;
    }
  };

  const answerOnTask = async ({ pmid, taskId, value, isQuiz, courseId }) => {
    try {
      const result = await answerOnTaskTrigger({ pmid, taskId, value, isQuiz }).unwrap();
      if (!isQuiz) {
        enqueueSnackbar(i18next.t('tasks.answerSubmitted'), { variant: TOAST_SUCCESS });
      }
      return result;
    } catch (error) {
      enqueueSnackbar(i18next.t('tasks.answerSubmittedFailed'), { variant: TOAST_ERROR });
      throw error;
    }
  };

  return {
    saveTaskFeedback,
    answerOnTask,
  };
};
